<template>
  <div>
    <PageAllow controller="Receipt" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportBatchExcel()"
              >
                <!-- <v-icon x-small class="pe-1">fa-file-export</v-icon> -->
                {{ $t("Receipt.Fields.bill_details_batch_export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="options.bill_code"
                    @text="bill_code = $event"
                    :label="$t('Receipt.Fields.bill_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherBillType
                    v-model="typesSelected"
                    :obj-type="options.obj_type"
                  />
                </v-col>
                <!-- 门店搜索 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    typesSelected == 201 &&
                    accountUser &&
                    accountUser.supplier &&
                    accountUser.supplier.order_to_purchase == 1
                  "
                >
                  <v-row dense align="center" class="pa-1 pe-2">
                    <SearcherShop
                      v-model="shopsSelected"
                      :districtCodes="accountUser.supplier.city_1"
                  /></v-row>
                </v-col>
                <!-- 仓库搜索 -->
                <v-col cols="12" sm="6" md="4" v-if="typesSelected == 201">
                  <v-row dense align="center" class="pa-1 pe-2">
                    <SearcherStock v-model="stockSelected" :types="[0]"/>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 汇总 -->
        <div class="mx-4 mb-4" :items="bill_count">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  {{ $t("Receipt.Fields.account_statement")
                  }}{{ $t("Global.colon") }}
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money") }}
                    {{ bill_count.pay_fee_total | formatMoney }}
                  </v-list-item-content>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>
                  {{ $t("Receipt.Fields.return_order")
                  }}{{ $t("Global.colon") }}
                  <v-list-item-content class="align-end red--text">
                    {{ $t("Global.money") }}
                    {{ bill_count.receivable_fee_total | formatMoney }}
                  </v-list-item-content>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2 mb-1"
                    :href="'/#/receipt/' + item.id"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Receipt.actions.detail") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.actions.detail") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="Export(item.id)"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Receipt.actions.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("Receipt.actions.export") }}</span>
              </v-tooltip>
            </template>
            <!-- 单号 -->
            <template v-slot:item.bill_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.bill_code }}
              </span>
            </template>
            <!-- 门店名称 -->
            <template v-slot:item.shop_name="{ item }">
              {{
                item.stock_order
                  ? item.stock_order.bill_purchase
                    ? item.stock_order.bill_purchase.bill_for_stock_order
                      ? item.stock_order.bill_purchase.bill_for_stock_order
                          .obj_name
                      : ""
                    : ""
                  : ""
              }}
            </template>
            <!-- 仓库名称 -->
            <template v-slot:item.stock_name="{ item }">
              <span
                v-if="
                  item.stock_order &&
                  (!item.stock_order.bill_purchase ||
                    (item.stock_order.bill_purchase &&
                      !item.stock_order.bill_purchase.bill_for_stock_order))
                "
              >
                {{
                  item.stock_order
                    ? item.stock_order.stock
                      ? item.stock_order.stock.name
                      : ""
                    : ""
                }}
              </span>
            </template>
            <!-- 应收应付 -->
            <template v-slot:item.total_price="{ item }">
              <span class="text-no-wrap">
                {{ $t("Global.money") }}
                {{ item.total_price | formatMoney }}
              </span>
            </template>
            <!-- 创建时间 -->
            <template v-slot:item.created="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <!-- 客户名称 -->
            <template v-slot:item.name>
              <span>
                {{ accountUserName }}
              </span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import Receipt from "@/api/receipt";
import SearcherBillType from "@/components/plugins/SearcherBillType";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherShop from "@/components/plugins/SearcherShop";
import SearcherStock from "@/components/plugins/SearcherStock";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  obj_type: 2,
  bill_code: "",
  order_to_purchase_shop_id: [],
  stock_id: null,
  bill_types: [],
};
export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    bills: [],
    bill_count: {},
    loading: false,
    paging: {},
    bill_code: "",
    shopsSelected: null,
    stockSelected: null,
    typesSelected: null,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherBillType,
    SearcherKeyword,
    SearcherShop,
    SearcherStock,
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountUserName() {
      if (this.accountInfo && this.accountInfo.account_name)
        return this.accountInfo.account_name;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.receipt"),
        disabled: false,
        href: "/receipt",
      },
      {
        text: i18n.t("Nav.receiptDetail"),
        disabled: true,
        href: "/receipt",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Receipt.Fields.created_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("Receipt.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill_code",
        },
        {
          text: i18n.t("Receipt.Fields.name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.typesSelected == 201 || this.typesSelected == 202) {
        if (
          this.accountUser &&
          this.accountUser.supplier &&
          this.accountUser.supplier.order_to_purchase == 1
        ) {
          headers.push({
            text: i18n.t("Receipt.Fields.shopName",[this.$consts.shopName()]),
            align: "start",
            sortable: false,
            value: "shop_name",
          });
        }
        headers.push({
          text: i18n.t("Receipt.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock_name",
        });
      }
      headers.push(
        {
          text: i18n.t("Receipt.Fields.credential_type"),
          align: "start",
          sortable: false,
          value: "bill_type_str",
        },
        {
          text: i18n.t("Receipt.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Receipt.Fields.receipt_pay"),
          align: "end",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    ...mapState(["accountUser", "accountInfo"]),
  },

  watch: {
    accountUser: {
      handler() {
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getReceiptFromAPI();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("receipt-options", JSON.stringify(this.options));
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getReceiptFromAPI();
        }
      },
    },
    stockSelected: {
      deep: true,
      handler() {
        this.options.stock_id = this.stockSelected
          ? this.stockSelected.id
          : null;
        sessionStorage.setItem(
          "receipt-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.order_to_purchase_shop_id = this.shopsSelected
          ? this.shopsSelected.id
          : null;
        sessionStorage.setItem(
          "receipt-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    typesSelected: {
      handler() {
        if (this.typesSelected != 201) {
          this.shopsSelected = null;
          this.stockSelected = null;
        }
        this.options.bill_types = this.typesSelected
          ? this.typesSelected
          : null;
        sessionStorage.setItem(
          "receipt-typesSelected",
          JSON.stringify(this.typesSelected)
        );
      },
    },
  },

  mounted() {
    this.$commonUtils
      .loadOptions("receipt", [
        "stockSelected",
        "shopsSelected",
        "typesSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockSelected":
                this.stockSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "typesSelected":
                this.typesSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        bill_code: this.bill_code,
      });
      this.getReceiptFromAPI();
    },
    resetSearch() {
      this.stockSelected = null;
      this.shopsSelected = null;
      this.typesSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.getReceiptFromAPI();
    },

    getReceiptFromAPI() {
      this.loading = true;
      Receipt.fetch(
        this.id,
        Object.assign(this.options, { cancel_flgs: 0 })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bills = response.data.bills;
            this.bill_count = response.data.bill_count;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },

    exportBatchExcel() {
      Receipt.exportBatchExcel(
        this.id,
        Object.assign(this.options, { cancel_flgs: 0 })
      );
    },
    Export(id) {
      Receipt.exportOne(Object.assign(id));
    },
  },
};
</script>

<style>
</style>